/* eslint-disable no-unused-vars */
/* eslint-disable prefer-rest-params */
/* eslint-disable prefer-spread */
/* eslint-disable no-param-reassign */

/**
 * Window class refactor of legacy G.Window to ES 6 class
 * @param {string} type
 * @param {Phaser.Group} [layer]
 */
export class Window extends Phaser.Group {
  /**
   * constructor
   * @param {Object} parent
   */
  constructor(parent) {
    super(game, parent);

    this.onClose = new Phaser.Signal();
    this.onFinishedEnter = new Phaser.Signal();

    this.buttonsList = [];
    this.state = game.state.getCurrentState();

    if (!this.NOFADEINOUT) {
      game.add.tween(this.scale).from({ x: 0 }, 300, Phaser.Easing.Elastic.Out, true);
      game.add.tween(this).from({ alpha: 0 }, 200, Phaser.Easing.Sinusoidal.In, true)
        .onComplete.add(() => { this.onFinishedEnter.dispatch(); });
    } else {
      this.onFinishedEnter.dispatch();
    }

    G.sb('onWindowOpened').dispatch(this, this.parent);
    G.Utils.cleanUpOnDestroy(this, G.sb('onStateChange').add(this.lockInput, this));
  }

  /**
   * close window
   * @param {Function} callback
   * @param {Object} context
   */
  closeWindow(callback, context) {
    if (this.closing) return;

    this.lockInput();

    this.closing = true;
    this.onClose.dispatch();

    if (this.boosterHighlight) {
      this.boosterHighlight.inputEnabled = false;
      game.add.tween(this.boosterHighlight.shine).to({ alpha: 0 }, 800, Phaser.Easing.Sinusoidal.Out, true).onComplete.add(() => {
        this.boosterHighlight.destroy();
      }, this);
    }

    game.add.tween(this.scale).to({ x: 1.5 }, 200, Phaser.Easing.Sinusoidal.In, true);
    game.add.tween(this).to({ alpha: 0 }, 200, Phaser.Easing.Sinusoidal.Out, true).onComplete.add(() => {
      G.sb('onWindowClosed').dispatch();
      this.destroy();
      if (callback) {
        callback.call(context || false);
      }
    }, this);
  }

  /**
   * add a background image
   * @param {Object} image Phaser.Image
   */
  addBackground(image) {
    image = image || 'popup';
    this.bg = G.makeImage(0, 0, image, 0.5, this);
  }

  /**
   * add a 9 slice generic background
   * @param {*} height
   */
  addGeneric9SliceBackground(width = 639, height = 600) {
    const bg = new PhaserNineSlice.NineSlice(0, 0, 'ssheet', 'popup_generic', width, height, G.OMTsettings.elements.windowNineSlice);
    bg.anchor.set(0.5);
    this.addChildAt(bg, 0);
    return bg;
  }

  /**
   * add the close button
   * @param {number} x
   * @param {number} y
   * @param {Function} callback
   * @param {Object} context
   */
  addCloseButton(x, y, callback, context) {
    callback = callback || false;
    context = context || this;
    this.closeButton = new G.Button(x || 250, y || -270, 'btn_x', () => {
      this.closeWindow(callback, context);
    }, this);

    this.registerButtons(this.closeButton);
  }

  /**
   * add the title text
   * @param {string} text
   */
  addTitle(text, style = G.OMTsettings.global.window.title.textStyle) {
    this.add(
      new G.Text(
        0, -270,
        OMT.language.getText(text),
        style,
        0.5,
        350,
      ),
    );
    this.add(this.titleText);
  }

  /**
   * set the title text
   * @param {string} text
   */
  setTitle(text) {
    this.titleText.setText(OMT.language.getText(text));
  }

  /**
   * register buttons to the window
   * @param {Object} obj not used ?
   */
  registerButtons(obj) {
    for (let i = 0; i < arguments.length; i++) {
      this.buttonsList.push(arguments[i]);
      this.add(arguments[i]);
    }
  }

  /**
   * force window to fit on screen
   */
  forceFitOnScreen() {
    const bounds = this.getBounds(game.stage);
    if (bounds.y < 0) {
      const newHeight = bounds.height + (bounds.y * 2);
      // enforce max scale down of 50%
      if (newHeight >= bounds.height / 2) {
        this.height = newHeight;
        this.scale.x = this.scale.y;
      }
    }
  }

  /**
   * lock user input
   */
  lockInput() {
    this.buttonsList.forEach((child) => {
      child.input.enabled = false;
    });
  }

  /**
   * unlock user input
   */
  unlockInput() {
    this.buttonsList.forEach((child) => {
      child.input.enabled = true;
      child.input.useHandCursor = true;
    });
  }

  /**
   * shows a semi transperant black overlay below the FB switch game UI, and prevent clicks on UI in background
   */
  showOverlay() {
    this.overlay = game.add.graphics();
    this.overlay.beginFill(0x000000, 0.7);
    this.overlay.drawRect(0, 0, game.width, game.height);
    this.overlay.inputEnabled = true;
  }

  hideOverlay() {
    this.overlay.destroy();
  }
}


/**
 * hack for legacy G.Window so code doesnt break
 */
class LegacyWindow extends Window {
  /**
   * constructor
   * @param {*} type
   * @param {Object} parent
   */
  constructor(type, parent) {
    super(parent);

    // apply arguements to startup function for window
    if (type.constructor === Array) {
      this[type[0]].apply(this, type.slice(1));
    } else {
      this[type].apply(this, Array.prototype.slice.call(arguments, 1));
    }
  }
}

// create global references
if (!window.Windows) window.Windows = {};
Windows.base = Window;

// legacy refernce for old windows
G.Window = LegacyWindow;
